export default {
  main: '#000000',
  secondary: '#EBC15B',
  contrastingColor: '#ffffff',
  priceColor: '#EBC15B',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
